import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import LogList from './list'
import LogDetails from './details'

class Log extends PureComponent {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.shape(),
    }).isRequired,
  }

  render() {
    const { location, ...props } = this.props
    if (location.query.id) {
      return <LogDetails id={location.query.id} />
    }
    return <LogList {...props} />
  }
}

export default Log



// WEBPACK FOOTER //
// ./src/views/log/index.js